import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";

const MAX_FAILURES = 40;

export const useJob = (jobId) => {
  const [job, setJob] = useState(null);
  const [error, setError] = useState("");
  const [offline, setOffline] = useState(false);
  const [version, setVersion] = useState(0);

  useEffect(() => {
    let timer;
    let stopped = false;
    let failures = 0;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/jobs/${jobId}`, { timeout: 15000 });
        failures = 0;
        setOffline(false);
        setJob(data);
        if (data.status === "error") return setError(data.error);
        if (data.status === "done") return;
      } catch (e) {
        if (e.response?.status === 404) return setError(e.response.data?.detail || "Conversione non trovata o scaduta.");
        failures += 1;
        setOffline(true);
        if (failures >= MAX_FAILURES) return setError("Connessione persa con il server. Ricarica la pagina per riprovare.");
      }
      if (!stopped) timer = setTimeout(poll, failures ? 3000 : 1500);
    };
    poll();
    return () => {
      stopped = true;
      clearTimeout(timer);
    };
  }, [jobId, version]);

  return { job, error, offline, refresh: () => setVersion((v) => v + 1) };
};
